'use client'

import { useState } from 'react'
import { HeartOff } from 'lucide-react'
import ProductCard from '../product/ProductCard'
import EmptyState from '@/components/elements/EmptyState'
import Skeleton from '@/components/elements/Skeleton'

export default function Wishlist({ wishlist, vendor }: { wishlist: any, vendor: any }) {
  const [prevWishlist, setPrevWishlist] = useState<any>(undefined)
  const [isLoading, setIsLoading] = useState(true)

  if (wishlist !== prevWishlist) {
    setPrevWishlist(wishlist)
    if (wishlist !== undefined && wishlist !== null) setIsLoading(false)
  }

  if (isLoading) return <WishlistSkeleton />

  const products: any[] = wishlist?.products || []
  const total = products.length
  const saleCount = products.filter(p => p?.variant?.sale && p.variant.sale < (p.variant?.price ?? 0)).length

  return (
    <div className="sm:p-3 space-y-5">
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-[-0.7%]">Хүслийн жагсаалт</h1>
        <p className="text-sm text-muted-foreground mt-1">
          {total > 0 ? <><span className="tabular-nums">{total}</span> бүтээгдэхүүн{saleCount > 0 ? <> · <span className="tabular-nums">{saleCount}</span>-ийн үнэ хямдарсан байна</> : null}</> : 'Жагсаалт хоосон байна'}
        </p>
      </div>

      {total > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-8">
          {products.map((product: any, index: number) => {
            const uniqueKey = `${product.id}-${product.variant?.id || `wishlist-${index}`}`
            return <ProductCard key={uniqueKey} product={product} vendor={vendor} showVariantName />
          })}
        </div>
      ) : (
        <div className="py-6">
          <EmptyState icon={HeartOff} title="Хүслийн жагсаалт хоосон байна" description="Таны жагсаалтад нэмсэн бараа энд харагдах болно." />
        </div>
      )}
    </div>
  )
}

function WishlistSkeleton() {
  return (
    <div className="sm:p-3 space-y-5">
      <div className="flex flex-col gap-1">
        <Skeleton className="w-56 h-8" />
        <Skeleton className="w-72 h-5" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-8">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="flex flex-col gap-2">
            <Skeleton className="w-full aspect-square rounded-xl" />
            <Skeleton className="w-3/4 h-4" />
            <Skeleton className="w-2/3 h-4" />
            <Skeleton className="w-1/2 h-4" />
          </div>
        ))}
      </div>
    </div>
  )
}
